<template>
  <div class="content" v-if="$auth.ready()" style="overflow: auto;" :style="modalOpen === true ? 'margin-top: 12rem' : 'margin-top: 2rem'">
    <div class="content">
      <h1 class="has-text-centered has-text-white">
        <span style="color: yellow;">FREE TRIAL! TEAM CHANGE RISK ASSESSMENT</span>
      </h1>
    </div>
    <div class="columns is-centered is-gapless">
      <div class="column is-half-tablet is-one-third-desktop">
        <div class="box">
          <form id="fromData">
            <div class="field" v-if="step === 1">
              <h2 class="has-text-primary has-text-centered">
                Welcome to ChangeVU!
              </h2>
              <hr></hr>
              <p class="intro-text">
                Please enter your email address. <br/>
                <span style="color:grey; font-size:0.75rem">(Your email is safe with us. We will not spam you.)</span> <br/>
                Create your account and assessment date. <br/>
                Invite team members & run your free trial!
              </p>

              <div class="field">
                <label class="label">Your email</label>
                <p class="control has-icon">
                  <input v-model="user.email" class="input" type="text" placeholder="name@example.com">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                </p>
                <!-- <p class="help has-text-grey">
                  By providing your email address you are agreeing to <a href="https://www.changevu.com/termsofservice.html" target="_blank">ChangeVU's terms of service</a>
                </p> -->
              </div>
              <div class="field">
                <div class="control">
                  <label class="checkbox help has-text-grey">
                    <input type="checkbox" v-model="user.agree">
                    I agree to the&nbsp;<a href="#/terms" target="_blank">ChangeVU Terms of Use</a>
                  </label>
                </div>
              </div>
            </div>
            <div class="field" v-if="step === 2">
              <h2 class="has-text-primary has-text-centered">Check your email!</h2>
              <hr></hr>
              <p class="intro-text">
                We've sent a 6-digit confirmation code to <strong>{{this.user.email}}</strong>. It will expire shortly, so enter it soon.
              </p>

              <Sms v-model="verificationDigits"></Sms>
              <p class="intro-text has-text-grey-light">
                Keep this window open while checking for your code. Remember to try your spam folder!
              </p>
            </div>
            <div class="field" v-if="step === 3">
              <h2 class="has-text-primary has-text-centered">Your email is verified!</h2>
              <hr></hr>
              <p class="intro-text">
                Please add and confirm your password to complete your account set up.
              </p>

              <div class="field">
                <label class="label">Your name</label>
                <p class="control has-icon">
                  <input v-model="user.firstName" class="input" type="text" placeholder="Your first name">
                  <span class="icon is-small">
                    <i class="fa fa-user"></i>
                  </span>
                </p>
                <p class="control has-icon">
                  <input v-model="user.lastName" class="input" type="text" placeholder="Your last name">
                  <span class="icon is-small">
                    <i class="fa fa-user"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label">Password</label>
                <p class="control has-icon">
                  <input v-model="user.password" class="input" type="password" placeholder="Password">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                </p>
                <p class="help">Password should be minimum 8 characters which contain at least one numeric digit and a special character.</p>
              </div>
              <div class="field">
                <label class="label">Confirm password</label>
                <p class="control has-icon">
                  <input v-model="user.confirmPassword" class="input" type="password" placeholder="Confirm password">
                  <span class="icon is-small">
                    <i class="fa fa-lock"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="field" v-if="step === 4">
              <h2 class="has-text-primary has-text-centered">
                Two more steps!
              </h2>
              <hr></hr>
              <p class="intro-text">
                Please add initiative information (below). <br />
                Then add team members (next page)...<br />
                ...and you're ready to go!<br />
              </p>

              <div class="field">
                <label class="label">Organization name</label>
                <p class="control has-icon">
                  <input v-model="client.companyName" class="input" type="text" placeholder="Organization name">
                  <span class="icon is-small">
                    <i class="fa fa-building"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label">Your team name</label>
                <p class="control has-icon">
                  <input v-model="initiative.teamName" class="input" type="text" placeholder="Your team name">
                  <span class="icon is-small">
                    <i class="fa fa-users"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label">
                  Initiative name
                  <span class="tooltip" v-tooltip.top="'Please add initiative, project or other program name.'">
                    <i class="fa fa-question-circle"></i>
                  </span>
                </label>
                <p class="control has-icon">
                  <input v-model="initiative.initiativeName" class="input" type="text" placeholder="Initiative name">
                  <span class="icon is-small">
                    <i class="fa fa-address-book"></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <label class="label">
                  Assessment due date
                  <span class="tooltip" v-tooltip.top="'Date to complete assessment for all members.'">
                    <i class="fa fa-question-circle"></i>
                  </span>
                </label>
                <p class="control has-icon deadlineInput">
                  <datetime v-model="initiative.deadline" :min-datetime="new Date().toISOString()" 
                  :max-datetime="new Date(Date.now() + 90 * 24*60*60*1000).toISOString()"
                  :use12-hour="true" type="datetime" :minute-step="15" :auto="true" 
                  :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                  :placeholder="datePlaceholder"></datetime>
                  <span class="icon is-small">
                    <i class="fa fa-calendar"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="field" v-if="step === 5">
              <h2 class="has-text-primary has-text-centered">
                Last step!
              </h2>
              <hr></hr>
              <p class="intro-text">
                Please add your team member’s email addresses.<br/>
                They will automatically be invited to the assessment.
              </p>

              <p class="control has-text-right">
                <a @click="previewModal()">
                  <i class="fa fa-list-alt"></i> Email Preview
                </a>
              </p>
              <div class="field" v-for="(input,k) in members" :key="k">
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" v-model="members[k].email" placeholder="name@example.com">
                  <span class="icon is-small is-left">
                    <i class="fa fa-envelope"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fa fa-times-circle" @click="remove(k)" v-show="k || ( !k && members.length > 1)"></i>
                  </span>
                </p>
                <p class="control has-text-right" v-show="members.length <= 9">
                  <a @click="add(k)" v-show="k === members.length-1">
                    <i class="fa fa-plus-circle"></i> Add another
                  </a>
                </p>
              </div>
              <p class="help" v-show="members.length > 9">
                You can add a maximum of 10 team members in the free risk assessment. <a @click="contactModal()">Contact us</a> to upgrade.
              </p>
            </div>
            <div class="field">
              <p class="control progress-btn" :class="{ 'btnCenter' : step !== 1}">
                <span class="step1msg" v-if="step === 1">
                  <p class="red">No credit card required</p>
                  <a href="#/login">Already have a free trial account?</a>
                </span>
                <button v-if="step === 1" @click.prevent="onBoard(1)" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                <button v-if="step === 2" @click.prevent="onBoard(2)" class="button is-primary">Confirm</button>
                
                <button v-if="step === 3 " @click.prevent="onBoard(3)" class="button is-primary">Next &nbsp;<i class="fa fa-chevron-right"></i></button>
                
                <!-- <button v-if="step === 4" @click.prevent="prev()" class="button is-light btnLeft"><i class="fa fa-chevron-left"></i>&nbsp;Back</button> -->
                <button v-if="step === 4" @click.prevent="onBoard(4)" class="button is-primary btnRight">Next &nbsp;<i class="fa fa-chevron-right"></i></button>

                <!-- <button v-if="step === 5" @click.prevent="prev()" class="button is-light btnLeft"><i class="fa fa-chevron-left"></i>&nbsp;Back</button> -->
                <button v-if="step === 5" @click.prevent="onBoard(5)" class="button is-primary btnRight">Done&nbsp;<span class="is-hidden-mobile">&amp; Do My Assessment</span>&nbsp;<i class="fa fa-chevron-right"></i></button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
      
    <div class="modal previewModal" :class="{ isActive: modalOpen }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box is-paddingless">
          <div class="preview-header has-text-centered">
            <img src="https://www.changevu.com/img/logo2x.png" href="https://www.changevu.com/" alt="ChangeVU" width="150px">
            <button class="delete" aria-label="close" @click="closeModal()"></button>
          </div>
          <div class="preview-banner has-text-centered">
            <img src="https://www.changevu.com/img/banners/changeLeaders.jpg" href="https://www.changevu.com/" alt="ChangeVU">
          </div>
          <div class="preview-body has-text-white">
            <div class="content">
              <h2 class="has-text-white">
                You've been invited to join ChangeVU's change risk assessment.
              </h2>
              <p>
                {{ this.user.firstName }} invited you to run a team change risk assessment.
              </p>
              <p>
                Click the link below to accept the invitation.<br />
                Validate your email and password to access the change risk assessment.
              </p>
              <p>
                You have until {{ this.initiative.deadline }} to complete the assessment.<br />
                You will then receive your individual and team reports.
              </p>
              <table class="table">
                <tbody>
                  <tr>
                    <td width="125px">Team Name:</td>
                    <td>{{ this.initiative.teamName }}</td>
                  </tr>
                  <tr>
                    <td width="125px">Team Leader:</td>
                    <td>{{ this.user.firstName }} {{ this.user.lastName }}</td>
                  </tr>
                  <tr>
                    <td width="125px">Initiative name:</td>
                    <td>{{ this.initiative.initiativeName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="preview-body-button">
            <div class="content">
              <p class="has-text-centered">
                <button class="button is-primary has-text-black">Accept Invitation</button>
              </p>
            </div>
          </div>
          <div class="preview-body has-text-white">
            <div class="content">
              <p>
                Welcome to ChangeVU!<br /><br />
                Thanks,<br />ChangeVU Team
              </p>
            </div>
          </div>
          <div class="preview-footer">
            <div class="footer-img">
              <img src="https://x5n8g.mjt.lu/tplimg/x5n8g/b/xzs81/oi9i.jpeg" alt="Connect to better change navigation">
            </div>
            <p class="has-text-centered">
              <a href="#" style="color: #9B9B9B;">Unsubscribe</a> to stop receiving these emails from us.<br/>
              Straticom Technologies R&D, 931 Lake Drive North, Georgina, Ontario, L4P3E9<br/>
              © 2020 Straticom Technologies R&D, all rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
      
      <div class="modal contactModal" :class="{ isActive: contactModalOpen }">
        <div class="modal-background"></div>
        <div class="modal-content">
          <div class="box">
            <div class="content">
              <h2 class="is-title is-bold has-text-centered has-text-primary">
                Contact Us
              </h2>
              <button class="delete" aria-label="close" @click="closeContactModal()"></button>
            </div>
            <hr></hr>
            <form>
              <div class="field">
                <label class="label">Your Message</label>
                <div class="control">
                  <textarea class="textarea" v-model="message" rows="3" placeholder="Your Message"></textarea>
                </div>
              </div>
              <div v-if="message" class="field">
                <div class="control has-text-centered">
                  <button @click.prevent="contactSubmit()" class="button is-primary">Send</button>
                </div>
              </div>
              <div v-if="!message" class="field">
                <div class="control has-text-centered">
                  <button class="button is-primary" disabled>Send</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import 'assets/scss/tooltip.scss'
import router from '../../router'
import Tooltip from 'vue-directive-tooltip'
import Vue from 'vue'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

import Sms from 'ofcold-security-code'

Vue.use(Tooltip)

export default {
  components: {
    datetime: Datetime,
    Sms
  },
  data () {
    return {
      message: '',
      datePlaceholder: 'Set due date',
      modalOpen: false,
      contactModalOpen: false,
      step: 1,
      isInvited: false,
      verificationNumber: '',
      verificationDigits: '',
      user: {
        email: '',
        agree: false,
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        type: '',
        role: ''
      },
      client: {
        id: '',
        companyName: '',
        contactPerson: {
          firstName: '',
          lastName: '',
          email: '',
          role: ''
        }
      },
      initiative: {
        id: '',
        initiativeName: '',
        deadline: '',
        teamName: ''
      },
      members: [
        {
          email: ''
        },
        {
          email: ''
        },
        {
          email: ''
        }
      ]
    }
  },
  mounted () {
  },
  methods: {
    login () {
      this.$auth.login({
        url: globalConstants.apiURL + '/auth/local',
        body: this.user,
        success: function (res) {
          axios.get(globalConstants.apiURL + '/auth/local')
          .then(response => {
            this.step++
            this.$cookie.set('token', res.data.token)
            this.$cookie.set('role', response.data.role)
            this.$store.commit('setUserImageSrc', globalConstants.apiURL + '/uploads/' + 'extra-large.jpg')
            this.$store.commit('setClientLogoSrc', globalConstants.apiURL + '/uploads/' + 'changeVULogo.png')
            this.$store.commit('setCurrentUserName', response.data.firstName)
            window.localStorage.setItem('user', JSON.stringify(response.data))

            // following code needs to optimized
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.user = user
            let currentInitiative = JSON.parse(window.localStorage.getItem('Initiative'))
            this.currentInitiative = currentInitiative
            let diagonactic
            if (currentInitiative) {
              for (var i = 0; i < user.diagonactics.length; i++) {
                if (user.diagonactics[i].initiative === currentInitiative.id) {
                  diagonactic = user.diagonactics[i]
                  break
                }
              }
            }
            if (diagonactic) {
              this.$store.commit('setIdentifySponsor', diagonactic.risks[0] ? diagonactic.risks[0] : '')
              this.$store.commit('setVisionClarity', diagonactic.risks[1] ? diagonactic.risks[1] : '')
              this.$store.commit('setSponsoringCoalition', diagonactic.risks[2] ? diagonactic.risks[2] : '')
              this.$store.commit('setSponsorCapability', diagonactic.risks[3] ? diagonactic.risks[3] : '')
              this.$store.commit('setGovernance', diagonactic.risks[4] ? diagonactic.risks[4] : '')
              this.$store.commit('setProgrammeManagement', diagonactic.risks[5] ? diagonactic.risks[5] : '')
              this.$store.commit('setBudgetingandResourcing', diagonactic.risks[6] ? diagonactic.risks[6] : '')
              this.$store.commit('setProgrammeDelivery', diagonactic.risks[7] ? diagonactic.risks[7] : '')
              this.$store.commit('setBusinessRequirements', diagonactic.risks[8] ? diagonactic.risks[8] : '')
              this.$store.commit('setOrganizationDesign', diagonactic.risks[9] ? diagonactic.risks[9] : '')
              this.$store.commit('setChangeReadiness', diagonactic.risks[10] ? diagonactic.risks[10] : '')
              this.$store.commit('setImplementationPlanning', diagonactic.risks[11] ? diagonactic.risks[11] : '')
              this.$store.commit('setChangeLeadership', diagonactic.risks[12] ? diagonactic.risks[12] : '')
              this.$store.commit('setStakeholderEngagement', diagonactic.risks[13] ? diagonactic.risks[13] : '')
              this.$store.commit('setImplementationCapability', diagonactic.risks[14] ? diagonactic.risks[14] : '')
              this.$store.commit('setSupportPeoplesJournery', diagonactic.risks[15] ? diagonactic.risks[15] : '')
            }
          })
          .catch(error => {
            console.log(error)
          })
        },
        data: this.user
      })
    },
    validateEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validatePassword (password) {
      var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/
      return re.test(password)
    },
    onBoard (step) {
      if (step === 1) {
        if (this.user.email === undefined || this.user.email === null || this.user.email.trim() === '') {
          this.$noty.error('Please enter your email address.')
        } else if (this.user.agree === false) {
          this.$noty.error('Please accept our Terms of Use')
        } else {
          axios.post(globalConstants.apiURL + '/api/v1/onboardUser', {email: this.user.email})
            .then(response => {
              this.verificationNumber = response.data.number
              this.step++
            })
            .catch(error => {
              this.$noty.error(error.response.data.message)
            })
        }
      } else if (step === 2) {
        if (this.verificationDigits.toString() === undefined || this.verificationDigits.toString() === null || this.verificationDigits.toString() === '') {
          this.$noty.error('Please enter the verification code.')
        } else if (this.verificationNumber.toString() === this.verificationDigits.toString()) {
          this.user.type = 'companyAdmin'
          this.user.role = 'TL'
          this.step++
        } else {
          this.$noty.error('Verification code did not match. Please check your email.')
        }
      } else if (step === 3) {
        if (this.user.firstName === undefined || this.user.firstName === null || this.user.firstName.trim() === '') {
          this.$noty.error('Please enter your first name.')
        } else if (this.user.lastName === undefined || this.user.lastName === null || this.user.lastName.trim() === '') {
          this.$noty.error('Please enter your last name.')
        } else if (this.user.password === undefined || this.user.password === null || this.user.password.trim() === '') {
          this.$noty.error('Please enter a password.')
        } else if (!this.validatePassword(this.user.password)) {
          this.$noty.error('Password should be minimum 8 characters which contain at least one numeric digit and a special character.')
        } else if (this.user.confirmPassword === undefined || this.user.confirmPassword === null || this.user.confirmPassword.trim() === '') {
          this.$noty.error('Please confirm the password.')
        } else if (this.user.password !== this.user.confirmPassword) {
          this.$noty.error('Password and confirm password does not match.')
        } else {
          if (this.user.role) {
            this.user.role = 'TM'
          }
          axios.post(globalConstants.apiURL + '/api/v1/users', {user: this.user})
            .then(response => {
              this.login()
              // this.step++ moved to login function
            })
            .catch(error => {
              console.log('error on saving users' + error)
              this.$noty.error(error.response.data.message)
            })
        }
      } else if (step === 4) {
        if (this.client.companyName === undefined || this.client.companyName === null || this.client.companyName.trim() === '') {
          this.$noty.error('Please enter your organization name.')
        } else if (this.initiative.teamName === undefined || this.initiative.teamName === null || this.initiative.teamName.trim() === '') {
          this.$noty.error('Please enter your team name.')
        } else if (this.initiative.initiativeName === undefined || this.initiative.initiativeName === null || this.initiative.initiativeName.trim() === '') {
          this.$noty.error('Please enter initiative name.')
        } else if (this.initiative.deadline === undefined || this.initiative.deadline === null || this.initiative.deadline.trim() === '') {
          this.$noty.error('Please set a deadline for the risk assessment.')
        } else {
          this.client.contactPerson.email = this.user.email
          this.client.contactPerson.firstName = this.user.firstName
          this.client.contactPerson.lastName = this.user.lastName
          this.client.contactPerson.role = this.user.role
          axios.post(globalConstants.apiURL + '/api/v1/clients', this.client)
            .then(response => {
              this.client.id = response.data.client._id
              this.initiative.deadline = new Date(this.initiative.deadline).toUTCString()
              axios.post(globalConstants.apiURL + '/api/v1/initiatives', {initiative: this.initiative, userID: response.data.userId})
              .then(response1 => {
                this.initiative.id = response1.data._id
                this.initiative.deadline = new Date(response1.data.deadline).toLocaleString()
                this.step++
              })
              .catch(error => {
                console.log('error on saving initiative' + error)
                this.$noty.error(error.response.data.message)
              })
            })
            .catch(error => {
              console.log('error on saving client' + error.response.data.message)
            })
        }
      } else if (step === 5) {
        let memberCount = 0
        this.members.forEach(element => {
          if (element.email !== undefined && element.email !== null && element.email !== '') {
            if (!this.validateEmail(element.email)) {
              this.$noty.error('Please enter valid email address.')
              element.email = ''
            } else {
              memberCount++
            }
          }
        })
        if ((new Set(this.members)).size !== this.members.length) {
          this.$noty.error('Please invite different members.')
        }
        if (memberCount > 2) {
          axios.post(globalConstants.apiURL + '/api/v1/invite', {inviter: this.user, members: this.members, initiativeID: this.initiative.id})
          .then(response => {
            router.push({ path: '/home' })
          })
          .catch(error => {
            console.log('error on saving client' + error)
            this.$noty.error(error.response.data.message)
          })
        } else {
          this.$noty.error('Please invite at least three members to this risk assessment.')
        }
      }
    },
    prev () {
      this.step--
    },
    add (index) {
      this.members.push({ email: '' })
    },
    remove (index) {
      this.members.splice(index, 1)
    },
    previewModal () {
      this.modalOpen = true
    },
    closeModal () {
      this.modalOpen = false
    },
    contactModal () {
      this.contactModalOpen = true
    },
    closeContactModal () {
      this.contactModalOpen = false
      this.message = ''
    },
    contactSubmit () {
      axios.post(globalConstants.apiURL + '/api/v1/submitContactForm', {name: this.user.firstName + ' ' + this.user.lastName, email: this.user.email, details: this.message})
      .then(response => {
        this.contactModalOpen = false
        this.message = ''
        this.$noty.success('Thanks for connecting with us. We will get back to you as soon as possible.')
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .intro-text {
    margin-bottom: 1rem !important;
  }
  @media screen and (max-width: 767px) {
    margin-top: 2rem;
  }
  .mb-2 {
    margin-bottom: 2rem !important;
  }
}
.code-input {
  align-items: center;
  justify-content: center;
  .input {
    width: 50px;
    height: 50px;
    @media screen and (max-width: 425px) {
      width: 30px;
      height: 30px;
    }
  }
}
.control.has-icons-right .icon {
  pointer-events: auto !important;
  cursor: pointer;
}

.checkbox {
  display: flex !important;
  align-items: center;
  input[type="checkbox"] {
    margin-right: 5px;
  }
}

.progress-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .step1msg {
    line-height: 1.25;
    .red {
      color: red;
    }
  }
}
.btnCenter {
  justify-content: center;
}
.btnRight {
  justify-content: flex-end;
}

.isActive {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.modal {
  top: 70px !important;
  height: 100%;
  .box {
    box-shadow: none !important;
  }
  @media screen and (max-width: 999px) {
    justify-content: flex-start;
    flex-direction: column;
    .modal-content {
      margin-top: 15%;
    }
  }
  .modal-content {
    // -ms-overflow-style: none;
    // scrollbar-width: none; 
    // overflow: -moz-scrollbars-none;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
  }
}
.previewModal {
  .modal-content {
    border-radius: 10px;
  }
  .preview-header {
    padding: 10px;
    position: relative;
    border-radius: 10px 10px 0px 0px;
    .delete {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  .preview-banner {
    background-color: #6666ff;
  }
  .preview-body {
    background-color: #6666ff;
    padding: 1rem;
    .content {
      h2 {
        margin-bottom: 1rem !important;
      }
      p {
        margin-bottom: 1rem !important;
      }
      .table {
        background-color: transparent;
        color: #fff;
        line-height: 1;
        tr {
          &:hover {
            background-color: transparent !important;
          }
          border: none !important;
          td {
            border: none !important;
            padding: 0.25em 0em;
          }
        }
      }
    }
  }
  .preview-body-button {
    padding: 1.5rem 0rem;
    .button {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }
  .preview-footer {
    color: #9B9B9B;
    background-color: #eee;
    padding: 0rem 0rem 1rem;
    border-radius: 0px 10px 10px 0px;
    a {
      text-decoration: underline;
    }
  }
}
.contactModal {
  .modal-content {
    border-radius: 10px;
    .box {
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0px;
        margin-top: 0px;
      }
      p {
        margin-bottom: 1rem;
      }
    }
  }
}
</style>

<style lang="scss">
.ofcold__security-code-wrapper .ofcold__security-code-field {
  width: 35px !important;
}
@media only screen and (max-width: 736px) {
  .ofcold__security-code-wrapper .ofcold__security-code-field .form-control {
    width: 38px !important;
    height: 38px !important;
  }
}
.ofcold__security-code-wrapper .ofcold__security-code-field .form-control {
  border: 1px solid #dbdbdb !important;
  border-radius: 3px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.deadlineInput {
  .vdatetime-input {
    padding-left: 2.25em;
    -moz-appearance: none;
    -webkit-appearance: none;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    box-shadow: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// OnBoard.vue?8bfe9754